import { Modal, Button } from 'antd'
import { orange, blue } from '@ant-design/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faClipboardList } from '@fortawesome/pro-solid-svg-icons'

type Props = {
  open: boolean
  onClose: () => void
  onScheduleJob: () => void
  onAddTask: () => void
}

const ScheduleEventTypePickerModal = ({ open, onClose, onScheduleJob, onAddTask }: Props) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="What would you like to schedule?"
      footer={null}
      width={400}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '16px 0' }}>
        <Button
          size="large"
          style={{ height: 60, display: 'flex', alignItems: 'center', gap: 12, fontSize: 16 }}
          onClick={onScheduleJob}
        >
          <FontAwesomeIcon icon={faBriefcase} style={{ fontSize: 20, color: orange.primary }} />
          Schedule a Job
        </Button>
        <Button
          size="large"
          style={{ height: 60, display: 'flex', alignItems: 'center', gap: 12, fontSize: 16 }}
          onClick={onAddTask}
        >
          <FontAwesomeIcon icon={faClipboardList} style={{ fontSize: 20, color: blue.primary }} />
          Add a Task
        </Button>
      </div>
    </Modal>
  )
}

export default ScheduleEventTypePickerModal
